export enum StatusCodes
{
    SUCCESS = 200,
    NO_CONTENT = 204,
    FORBIDDEN = 403,
    CONFLICT = 409,
    REGENERATE_TOKEN = 498,
    UN_AUTHORISED = 401,
    INTERNAL_SERVER_ERROR = 500
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/util/statuscodes.tsx